import { Link } from '@inertiajs/react'

interface Props {
  page_title: string
}

export default function Unsubscribed({ page_title }: Props) {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="max-w-md mx-auto text-center px-4">
        <h1 className="text-2xl font-semibold text-foreground mb-4">{page_title}</h1>
        <p className="text-muted-foreground mb-6">
          Você não receberá mais o resumo diário de notificações por email.
        </p>
        <Link
          href="/dashboard/notifications"
          className="inline-block px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium"
        >
          Ir para o Dashboard
        </Link>
      </div>
    </div>
  )
}
